import { Text } from '@optiaxiom/react';

import { ConfirmationModal } from '@frontend/components/confirmationModal/components/ConfirmationModal';

type StopExecutionDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
};

export function StopExecutionDialog({
  open,
  onOpenChange,
  onConfirm,
  isSubmitting = false,
}: StopExecutionDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <ConfirmationModal
      isShown={open}
      title="Stop Execution"
      action="Stop Execution"
      appearance="danger"
      onCancel={handleCancel}
      onConfirm={onConfirm}
      confirmLoading={isSubmitting}
      cancelDisabled={isSubmitting}
    >
      <Text>
        Are you sure you want to stop this execution? The agent has been terminated manually.
      </Text>
    </ConfirmationModal>
  );
}
